<sdps-notification type="information" class="sdps-m-top_none" *ngIf="!orgId">
  <p class="sdps-notification__text" [innerHTML]="emtrConstant.rulesConstant.ruleGlobalConst.noCientSelected"></p>
</sdps-notification>
<p *ngIf="orgId">
  rule-groups works!
</p>
